<div class="main-content">
  <div class="order-college-page container-fluid">
    <div class="page-header d-flex flex-wrap align-items-center justify-content-between mb-3">
      <h2 class="page-title">Foreign College Order</h2>
      <div class="header-actions mt-2 mt-md-0">
        <button class="btn btn-outline-secondary btn-sm w-100 w-md-auto" (click)="form.reset()">Reset</button>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="filter-form card p-3 mb-3">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <label class="form-label">Country</label>
          <select class="form-control" formControlName="country_id" (change)="onCountryChange($event)">
            <option value="">Select country</option>
            <option *ngFor="let c of countries; trackBy: trackById" [value]="c.id">{{ c.label }}</option>
          </select>
          <div *ngIf="form.controls.country_id.invalid && form.controls.country_id.touched" class="text-danger small">Country is required</div>
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label">Course</label>
          <select class="form-control" formControlName="course_id">
            <option value="">Select course</option>
            <option *ngFor="let c of courses; trackBy: trackById" [value]="c.id">{{ c.label }}</option>
          </select>
          <div *ngIf="form.controls.course_id.invalid && form.controls.course_id.touched" class="text-danger small">Course is required</div>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button type="submit" class="btn btn-primary w-100 w-md-auto" [disabled]="loading">
          <ng-container *ngIf="!loading">Search</ng-container>
          <ng-container *ngIf="loading">Searching...</ng-container>
        </button>
      </div>
    </form>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
    <div *ngIf="success" class="alert alert-success">{{ success }}</div>

    <div class="card grid-card p-2">
      <div #gridWrapper class="grid-wrapper">
        <ag-grid-angular
          class="ag-theme-alpine order-grid responsive-ag-grid"
          [gridOptions]="gridOptions"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="{resizable:true, sortable:true, filter:true, minWidth:100}"
          [rowHeight]="60"
          (gridReady)="onGridReady($event)"
          (cellClicked)="onCellClicked($event)"
        >
        </ag-grid-angular>
      </div>

      <div class="mt-2 d-flex justify-content-end gap-2 flex-wrap" *ngIf="editedMap.size > 0 || editingMode">
        <button class="btn btn-outline-secondary btn-sm w-100 w-md-auto" (click)="cancelEdits()" [disabled]="saving">Cancel</button>
        <button class="btn btn-success btn-sm w-100 w-md-auto" (click)="saveEdits()" [disabled]="saving || (editedMap.size === 0 && touchedSet.size === 0)">
          <ng-container *ngIf="!saving">Save</ng-container>
          <ng-container *ngIf="saving">Saving...</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
